import FacebookIcon from '@mui/icons-material/Facebook';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Grid2, Link as MuiLink, Typography } from '@mui/material';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <Box
      id="footer"
      component="footer"
      sx={{
        background: 'linear-gradient(-45deg,#3b87bd,#2d71a2)',
        color: 'white',
        padding: 1.25,
        textAlign: 'center',
        marginTop: 'auto',
        zIndex: '1300', //rendered on top of communicator
      }}
    >
      <Grid2 container spacing={2} alignItems="center" justifyContent="space-between">
        {/* First Column: Copyrights with link */}
        <Grid2 size={{ xs: 6 }}>
          <Typography variant="body2" sx={{ fontSize: '1rem' }}>
            © {new Date().getFullYear()}{' '}
            <MuiLink
              href="https://turnieje.org"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'white',
                textDecoration: 'underline',
                fontWeight: 'bold',
                '&:hover': {
                  color: '#ffeb3b', // Highlight color on hover
                },
              }}
            >
              Turnieje.org
            </MuiLink>
          </Typography>
        </Grid2>

        {/* Second Column: Icons */}
        <Grid2 size={{ xs: 6 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <MuiLink href="https://facebook.com/turnieje.org" target="_blank" rel="noopener noreferrer" sx={{ color: 'white' }}>
              <FacebookIcon />
            </MuiLink>
            <MuiLink href="mailto:kontakt@turnieje.org" target="_blank" rel="noopener noreferrer" sx={{ color: 'white' }}>
              <MailIcon />
            </MuiLink>
            <MuiLink href="tel:+48725291248" target="_blank" rel="noopener noreferrer" sx={{ color: 'white' }}>
              <PhoneIcon />
            </MuiLink>
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Footer;
